<template>
  <div>
    <div
      style="width: fit-content; padding: 0"
      @click="isCalendarActive = true"
      v-click-outside="closeCalendar"
      :style="customStyles"
    >
      <p class="date-input-header">
        {{ title }}

        <span v-if="isRequired && title" style="color: #e2037e">*</span>
      </p>
      <div
        class="input-date-wrapper"
        :style="width ? `min-width: unset; width: ${width}` : ''"
      >
        <img src="../../icons/dod/dodCalendarIcon.svg" alt="Calendar" />
        <span>{{ currentDate || placeholder }}</span>
        <span v-if="isRequired && !currentDate" style="color: #e2037e">*</span>
      </div>

      <!-- :min-date="minDate || new Date(new Date().getTime())"
        :max-date="maxDate || ''" -->
      <v-calendar
        v-if="isCalendarActive"
        style="position: absolute; z-index: 999"
        @dayclick="onDayClick"
      >
      </v-calendar>
    </div>
    <div v-if="errorMsg" class="custom-error-wrapper">
      <span class="custom-error-msg">
        {{ errorMsg }}
      </span>
    </div>
  </div>
</template>

<script>
import VCalendar from "v-calendar/lib/components/calendar.umd";
export default {
  components: {
    VCalendar,
  },
  props: [
    "title",
    "placeholder",
    "isRequired",
    "minDate",
    "maxDate",
    "customStyles",
    "prePick",
    "errorMsg",
    "width",
  ],
  emits: ["dateChange"],
  data() {
    return {
      currentDate: this.prePick ? this.prePick.slice(0, 10) : "",
      isCalendarActive: false,
    };
  },
  methods: {
    onDayClick(date) {
      this.currentDate = date.id;
      this.$emit("dateChange", this.currentDate);
    },
    closeCalendar() {
      this.isCalendarActive = false;
    },
  },
};
</script>

<style scoped>
.input-date-wrapper {
  display: flex;
  border: 1px solid #c1c1cf;
  color: #090741;
  border-radius: 5px;
  padding: 5px;
  align-items: center;
  font-size: 14px;
  min-width: 250px;
}
.input-date-wrapper img {
  margin-right: 10px;
}
.date-input-header {
  margin-bottom: 5px;
  font-weight: 700;
  font-size: 12px;
}
.input-date-wrapper span {
  line-height: 14px;
}
</style>
